// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1g0zd","rootSmall":"AddTileButton_rootSmall__3y9RU"};